/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Acted Core API
 * Core backend API.
 * OpenAPI spec version: 1.0.0
 */
import {
  HttpClient
} from '@angular/common/http';
import type {
  HttpContext,
  HttpEvent,
  HttpParams
} from '@angular/common/http';

import type {
  HttpHeaders,
  HttpResponse as AngularHttpResponse
} from '@angular/common/http';

import {
  Injectable,
  inject
} from '@angular/core';

import type {
  Observable
} from 'rxjs';

import type {
  ArchivesBalzacBooksListParams,
  ArchivesLandlordsListParams,
  ArchivesPartnersListParams,
  ArchivesPlacesListParams,
  ArchivesProjectContractsListParams,
  ArchivesSuppliersListParams,
  PaginatedArchivesBalzacBooksBALZACBookList,
  PaginatedArchivesPlacesPlaceListList,
  PaginatedArchivesProjectContractsProjectContractListList,
  PaginatedLandlordList,
  PaginatedPartnerList,
  PaginatedSupplierList
} from '../model';

import {
  environment
} from 'environments/environment';



import { filterParams, HttpClientBodyOptions, HttpClientEventOptions, HttpClientObserveOptions, HttpClientResponseOptions } from '../httpClientOptions';

@Injectable({ providedIn: 'root' })
export class ArchivesService {
  private readonly http = inject(HttpClient);
 balzacBooks<TData = PaginatedArchivesBalzacBooksBALZACBookList>(params?: ArchivesBalzacBooksListParams, options?: HttpClientBodyOptions): Observable<TData>;
 balzacBooks<TData = PaginatedArchivesBalzacBooksBALZACBookList>(params?: ArchivesBalzacBooksListParams, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 balzacBooks<TData = PaginatedArchivesBalzacBooksBALZACBookList>(params?: ArchivesBalzacBooksListParams, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  balzacBooks<TData = PaginatedArchivesBalzacBooksBALZACBookList>(
    params?: ArchivesBalzacBooksListParams, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    const filteredParams = filterParams({...params, ...options?.params}, new Set<string>([]));

    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `${environment.apiRoot}/api/archives/balzac-books/`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
        params: filteredParams,}
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `${environment.apiRoot}/api/archives/balzac-books/`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
        params: filteredParams,}
    );
    }

    return this.http.get<TData>(
      `${environment.apiRoot}/api/archives/balzac-books/`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
        params: filteredParams,}
    );
  }
 landlords<TData = PaginatedLandlordList>(params?: ArchivesLandlordsListParams, options?: HttpClientBodyOptions): Observable<TData>;
 landlords<TData = PaginatedLandlordList>(params?: ArchivesLandlordsListParams, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 landlords<TData = PaginatedLandlordList>(params?: ArchivesLandlordsListParams, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  landlords<TData = PaginatedLandlordList>(
    params?: ArchivesLandlordsListParams, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    const filteredParams = filterParams({...params, ...options?.params}, new Set<string>([]));

    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `${environment.apiRoot}/api/archives/landlords/`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
        params: filteredParams,}
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `${environment.apiRoot}/api/archives/landlords/`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
        params: filteredParams,}
    );
    }

    return this.http.get<TData>(
      `${environment.apiRoot}/api/archives/landlords/`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
        params: filteredParams,}
    );
  }
 partners<TData = PaginatedPartnerList>(params?: ArchivesPartnersListParams, options?: HttpClientBodyOptions): Observable<TData>;
 partners<TData = PaginatedPartnerList>(params?: ArchivesPartnersListParams, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 partners<TData = PaginatedPartnerList>(params?: ArchivesPartnersListParams, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  partners<TData = PaginatedPartnerList>(
    params?: ArchivesPartnersListParams, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    const filteredParams = filterParams({...params, ...options?.params}, new Set<string>([]));

    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `${environment.apiRoot}/api/archives/partners/`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
        params: filteredParams,}
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `${environment.apiRoot}/api/archives/partners/`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
        params: filteredParams,}
    );
    }

    return this.http.get<TData>(
      `${environment.apiRoot}/api/archives/partners/`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
        params: filteredParams,}
    );
  }
 places<TData = PaginatedArchivesPlacesPlaceListList>(params?: ArchivesPlacesListParams, options?: HttpClientBodyOptions): Observable<TData>;
 places<TData = PaginatedArchivesPlacesPlaceListList>(params?: ArchivesPlacesListParams, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 places<TData = PaginatedArchivesPlacesPlaceListList>(params?: ArchivesPlacesListParams, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  places<TData = PaginatedArchivesPlacesPlaceListList>(
    params?: ArchivesPlacesListParams, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    const filteredParams = filterParams({...params, ...options?.params}, new Set<string>([]));

    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `${environment.apiRoot}/api/archives/places/`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
        params: filteredParams,}
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `${environment.apiRoot}/api/archives/places/`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
        params: filteredParams,}
    );
    }

    return this.http.get<TData>(
      `${environment.apiRoot}/api/archives/places/`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
        params: filteredParams,}
    );
  }
 projectContracts<TData = PaginatedArchivesProjectContractsProjectContractListList>(params?: ArchivesProjectContractsListParams, options?: HttpClientBodyOptions): Observable<TData>;
 projectContracts<TData = PaginatedArchivesProjectContractsProjectContractListList>(params?: ArchivesProjectContractsListParams, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 projectContracts<TData = PaginatedArchivesProjectContractsProjectContractListList>(params?: ArchivesProjectContractsListParams, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  projectContracts<TData = PaginatedArchivesProjectContractsProjectContractListList>(
    params?: ArchivesProjectContractsListParams, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    const filteredParams = filterParams({...params, ...options?.params}, new Set<string>([]));

    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `${environment.apiRoot}/api/archives/project-contracts/`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
        params: filteredParams,}
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `${environment.apiRoot}/api/archives/project-contracts/`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
        params: filteredParams,}
    );
    }

    return this.http.get<TData>(
      `${environment.apiRoot}/api/archives/project-contracts/`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
        params: filteredParams,}
    );
  }
 suppliers<TData = PaginatedSupplierList>(params?: ArchivesSuppliersListParams, options?: HttpClientBodyOptions): Observable<TData>;
 suppliers<TData = PaginatedSupplierList>(params?: ArchivesSuppliersListParams, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 suppliers<TData = PaginatedSupplierList>(params?: ArchivesSuppliersListParams, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  suppliers<TData = PaginatedSupplierList>(
    params?: ArchivesSuppliersListParams, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    const filteredParams = filterParams({...params, ...options?.params}, new Set<string>([]));

    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `${environment.apiRoot}/api/archives/suppliers/`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
        params: filteredParams,}
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `${environment.apiRoot}/api/archives/suppliers/`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
        params: filteredParams,}
    );
    }

    return this.http.get<TData>(
      `${environment.apiRoot}/api/archives/suppliers/`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
        params: filteredParams,}
    );
  }
};

